export default __webpack_public_path__ + "static/media/argon-react-white.e4dd3b41.png";